





























import { Asset } from '@/js/Asset'
import { DEFAULT_NETWORK_NAME } from '@/store/modules/network/network'
import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class BalanceRow extends Vue {
    @Prop() asset!: Asset

    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
}
